import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "progressBar"]

  connect() {
    this.onScroll = () => this.updateProgress()
    this.trackTarget.addEventListener("scroll", this.onScroll)
    this.updateProgress()
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.onScroll)
  }

  next() {
    this.scrollByCard(1)
  }

  prev() {
    this.scrollByCard(-1)
  }

  scrollByCard(direction) {
    const card = this.trackTarget.firstElementChild
    if (!card) return

    const gap = parseFloat(getComputedStyle(this.trackTarget).columnGap || 0)
    const cardWidth = card.offsetWidth + gap
    this.trackTarget.scrollBy({ left: cardWidth * direction, behavior: "smooth" })
  }

  updateProgress() {
    const { scrollLeft, scrollWidth, clientWidth } = this.trackTarget
    const maxScroll = scrollWidth - clientWidth
    const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0
    const barWidth = this.progressBarTarget.offsetWidth
    const trackWidth = this.progressBarTarget.parentElement.offsetWidth
    const maxTranslate = trackWidth - barWidth

    this.progressBarTarget.style.transform = `translateX(${progress * maxTranslate}px)`
  }
}
